var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Col } from "react-bootstrap";
import { addDashIfNullOrUndefined, } from "@domains/utils/numberMethods";
import { useSelector } from "react-redux";
import di from "../di/serviceLocator";
import Loader from "../../../../../shared-library/components/Loader";
var PartnerBank = function (props) {
    var _a = __read(React.useState({
        bankDetails: [],
    }), 2), partnerBank = _a[0], setPartnerBank = _a[1];
    var selectedPartner = useSelector(function (state) {
        return state.Partners.partnerSummary.reducersData.selectedPartner;
    });
    var _b = useSelector(function (state) { return state.Partners.partnerProfDemMetNomSeg.commonData; }), overviewLoader = _b.loader, errorData = _b.errorData;
    var bankData = useSelector(function (state) {
        return state.Partners.partnerProfDemMetNomSeg.reducersData.bankData;
    });
    React.useEffect(function () {
        di.partnerOverview
            .getPartnerBankDetails({
            AcCode: selectedPartner.accountCode,
            flg: selectedPartner.flag,
            page: 1,
            pageSize: 100,
        })
            .then(function (data) {
            if (data)
                setPartnerBank(data);
        });
    }, [selectedPartner]);
    React.useEffect(function () {
        if (bankData !== null && bankData !== undefined)
            setPartnerBank(bankData);
    }, [bankData]);
    var generateBankDetails = function (bankDetails) {
        return (React.createElement(Col, null,
            React.createElement("div", { className: "d-grid profile-grid" },
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Bank Name",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.bankName))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Bank State",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.bankState))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Bank City",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.bankCity))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Bank PIN Code",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.bankPin))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Bank Address",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.bankAddress))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Account No",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.accountNo))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Account Type",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.accountType))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "IFSC Code",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.ifscCode))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "MICR",
                    React.createElement("div", { className: "RobotoM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.micr))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Name As Per Bank",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.nameAsPerBank))))));
    };
    return (React.createElement(React.Fragment, null, overviewLoader ? (React.createElement("div", { className: "position-relative client-loader" },
        React.createElement(Loader, null))) : (React.createElement("section", { id: "profile-details", className: "section-padding element" },
        React.createElement("label", { className: "DMSanBold_18_700 txt_blackOne1 label-padding" }, "Bank Details"),
        partnerBank.bankDetails.length > 0
            ? partnerBank.bankDetails.length === 1
                ? generateBankDetails(partnerBank.bankDetails[0])
                : partnerBank.bankDetails.map(function (item, index) {
                    return (React.createElement("div", { className: "d-flex flex-column gap-3 mb-4" },
                        React.createElement("div", { className: "txt_midnight-blue DMSans_16_500 text-decoration-underline" },
                            "Bank Details ",
                            index + 1),
                        generateBankDetails(item)));
                })
            : generateBankDetails()))));
};
export default PartnerBank;
